export default __webpack_public_path__ + "static/media/questionMarkIcon.fb682381.svg";